var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"mt-3 elevation-1",attrs:{"item-key":"id","disableSort":"","items-per-page":-1,"headers":_vm.headers,"items":_vm.items,"hide-default-footer":""},scopedSlots:_vm._u([{key:"item.index",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("ordinalNumber")(item,_vm.items))+"\n  ")]}},{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('CardStudentName',{attrs:{"student":item.student,"link":""}})]}},{key:"item.dob",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm._f("ddmmyyyy")(_vm.$_get(item, 'student.dob')))+"\n  ")]}},{key:"item.class",fn:function(ref){
var item = ref.item;
return [_vm._v("\n    "+_vm._s(_vm.$_get(item, 'class.title', '--'))+"\n  ")]}},{key:"item.status",fn:function(ref){
var item = ref.item;
return [_c('PopupUpdateStatusChange',{attrs:{"id":item.id,"srcStatus":item.status,"srcSubStatus":item.subStatus}})]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }